











































































import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import Button from '../components/common/Button/Button.vue';
import QualityGoalList from '../components/ReportView/QualityGoalList.vue';
import QualityReport from '../components/ReportView/QualityReport.vue';
import { QualityGoalType } from '../interfaces/types/QualityGoal';
import CreateQualityGoalModal from '../components/ReportView/CreateQualityGoalModal.vue';
import {
  deleteQualityGoal,
  getAllQualityGoals,
  getLabelsetById,
  setLastSelectedQualityGoal,
  removeLastSelectedQualityGoal,
  updateQualityGoal,
} from '@/utils/axiosInstances';
import SelectedQualityGoal from '../components/ReportView/SelectedQualityGoal.vue';
import { exportJSONToFile } from '@/utils/download';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  components: {
    GNB,
    Spinner,
    Button,
    QualityGoalList,
    QualityReport,
    CreateQualityGoalModal,
    SelectedQualityGoal,
  },
  data(): {
    qualityGoalList: QualityGoalType[];
    currentQualityGoal: QualityGoalType | undefined;
    isModalVisible: boolean;
    isQualityGoalModified: boolean;
    isExpanded: boolean;
  } {
    return {
      qualityGoalList: [],
      currentQualityGoal: undefined,
      isModalVisible: false,
      isQualityGoalModified: false,
      isExpanded: false,
    };
  },
  async created() {
    await this.handleRefreshLabelset();
  },
  async mounted() {
    window.onbeforeunload = this.handleBeforeUnload;

    await this.loadQualityGoalList();

    this.$store.commit('startLoading');
    const labelset = await getLabelsetById(this.labelsetId);

    if (!!labelset.qualityGoalId && labelset.qualityGoalId !== '') {
      this.currentQualityGoal = this.qualityGoalList.find(
        (q) => q.qualityGoalId === labelset.qualityGoalId,
      );
    }
    this.$store.commit('stopLoading');
  },
  beforeDestroy() {
    window.onbeforeunload = function () {
      // do nothing, removing event listener
    };
  },
  computed: {
    hasQualityGoal(): boolean {
      return !!this.currentQualityGoal;
    },
    workspaceId(): string {
      return this.$route.path.split('/')[2];
    },
    datasetId(): string {
      return this.$route.path.split('/')[4];
    },
    labelsetId(): string {
      return this.$route.path.split('/')[6];
    },
  },
  watch: {
    currentQualityGoal(newVal) {
      if (newVal === undefined) {
        this.$store.commit('startLoading');
        removeLastSelectedQualityGoal(this.labelsetId).finally(() => {
          this.$store.commit('stopLoading');
        });
      }
    },
  },
  methods: {
    async handleRefreshLabelset() {
      // 분석 결과가 store에 없는데 직접 URL로 접근한 경우 저장

      const parsedURL = this.$route.path.split('/');
      const datasetIdx = parsedURL.indexOf('dataset');
      const labelsetIdx = parsedURL.indexOf('labelset');

      await this.$store.dispatch('getChartAnalysisData', {
        APIURL: `/api/v1/datasets/${parsedURL[datasetIdx + 1]}/analysis/file`,
      });

      if (labelsetIdx != -1) {
        await this.$store.dispatch('getLabelChartAnalysisData', {
          APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
        });
        await this.$store.dispatch('getSchemaChartAnalysisData', {
          APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
        });
      }
    },
    handleBeforeUnload() {
      if (this.hasQualityGoal) {
        return true;
      }
    },
    createNewQualityGoal() {
      this.isModalVisible = true;
    },
    removeQualityGoal() {
      if (
        confirm(
          '품질 목표 적용을 해제하시겠습니까? 저장하지 않은 정보는 사라집니다.',
        )
      ) {
        this.currentQualityGoal = undefined;
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.loadQualityGoalList();
    },
    async loadQualityGoalList() {
      this.$store.commit('startLoading');
      try {
        const list = await getAllQualityGoals(this.workspaceId);
        this.qualityGoalList = list;
      } catch (error) {
        alert('품질 목표 목록을 불러오는 중 오류가 발생했습니다.');
        console.error(error);
      } finally {
        this.$store.commit('stopLoading');
      }
    },
    async selectQualityGoal(idx: number) {
      this.currentQualityGoal = this.qualityGoalList[idx];

      this.$store.commit('startLoading');
      const status = await setLastSelectedQualityGoal(
        this.labelsetId,
        this.currentQualityGoal.qualityGoalId ?? '',
      );
      this.$store.commit('stopLoading');
    },
    resizeSummaryComponent() {
      this.isExpanded = !this.isExpanded;
    },
    async saveQualityGoal() {
      showUnsupportedMessage(this.$toast);

      // if (confirm('변경 사항을 저장합니다.') && this.currentQualityGoal) {
      //   this.$store.commit('startLoading');
      //   const qualityGoalId = this.currentQualityGoal.qualityGoalId ?? '';
      //   const result = await updateQualityGoal(
      //     qualityGoalId,
      //     this.currentQualityGoal,
      //   );
      //   if (result !== 200) {
      //     alert('저장 중 오류가 발생했습니다.');
      //   }
      //   this.$store.commit('stopLoading');
      // }
    },
    async downloadQualityGoalJSON() {
      if (
        confirm('현재 품질 목표를 JSON 형태로 저장합니다.') &&
        this.currentQualityGoal
      ) {
        exportJSONToFile(this.currentQualityGoal, 'qualityGoal.json');
      }
    },
    async deleteQualityGoal() {
      showUnsupportedMessage(this.$toast);

      // if (confirm('품질 목표가 완전히 삭제됩니다.')) {
      //   const result = await deleteQualityGoal(
      //     this.currentQualityGoal?.qualityGoalId ?? '',
      //   );

      //   if (result !== 200) {
      //     alert('삭제 중 오류가 발생했습니다.');
      //   } else {
      //     this.currentQualityGoal = undefined;
      //     this.loadQualityGoalList();
      //   }
      // }
    },
  },
});
